/* A&B Motors — theme behaviour. Vanilla JS, no dependencies, no build step. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- utils */
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  function on(el, evt, fn) { if (el) el.addEventListener(evt, fn); }

  var header = $('[data-header]');
  if (header && 'ResizeObserver' in window) {
    new ResizeObserver(function () {
      document.documentElement.style.setProperty('--header-offset', header.offsetHeight + 'px');
    }).observe(header);
  }

  function money(cents) {
    var fmt = window.ABM && window.ABM.moneyFormat;
    var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!fmt) return '$' + value;
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value).replace(/\{\{\s*amount_no_decimals\s*\}\}/, value);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // The source system splits some makes by region or catch-all — "Nissan - Worldwide",
  // "General Motors - Foreign", "Miscellaneous - Trucks". Those strings are the tag the
  // catalogue filters on, so they cannot change, but they are internal vocabulary and a
  // shopper should not have to read it. Relabel for display only; the value stays the tag.
  //
  // The generic "X (y)" rewrite below is not enough on its own: "Miscellaneous (trucks)"
  // is still a database bucket, and "General Motors (foreign)" names a division rather
  // than the badge on the car — the models under it are Geo. Where a bucket has a name a
  // shopper would actually recognise, say that instead.
  //
  // "KIA" is a different defect with the same symptom. It is not a regional split: the
  // renderer's title-caser treats any token of three characters or fewer as an acronym,
  // which is right for BMW, GMC and MDX and wrong for the one make that is an ordinary
  // word. The catalogue is fixed at the source, but a tag is only respelled when its
  // product is republished, so the picker would keep shouting until every Kia part had
  // been through a sync. Relabelling costs nothing here: the tag handleizes to "kia"
  // either way, so the link this option builds is byte-identical.
  var MAKE_LABELS = {
    'Miscellaneous - Trucks': 'Other trucks',
    'General Motors - Foreign': 'Geo',
    'Nissan - Worldwide': 'Nissan (imported models)',
    'American Motors': 'AMC',
    'KIA': 'Kia'
  };

  function makeLabel(name) {
    var key = String(name);
    if (MAKE_LABELS[key]) return MAKE_LABELS[key];
    var split = key.split(' - ');
    return split.length === 2 ? split[0] + ' (' + split[1].toLowerCase() + ')' : key;
  }

  // Mirrors Shopify's own tag handleizing, which is what tag URLs are keyed on.
  // Both vehicle pickers build /collections/all/<tag> paths with it.
  function handleize(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // All vehicle controls share one request. Remember a choice only when it is applied,
  // and validate it against today's inventory before restoring it.
  var vehicleRequests = {};
  function loadVehicles(src) {
    if (window.ABMShopping) return window.ABMShopping.loadVehicles(src);
    if (!vehicleRequests[src]) {
      vehicleRequests[src] = fetch(src, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('Vehicle list unavailable');
          return r.json();
        });
    }
    return vehicleRequests[src];
  }

  function savedVehicle(json) {
    try {
      var saved = JSON.parse(localStorage.getItem('abm:vehicle'));
      var makes = json.makes || {};
      if (!saved || !Object.prototype.hasOwnProperty.call(makes, saved.make)) return null;
      if (!saved.model) return !saved.year && (json.make_only || Object.keys(makes)).indexOf(saved.make) !== -1 ? saved : null;
      if (!Object.prototype.hasOwnProperty.call(makes[saved.make], saved.model)) return null;
      var years = makes[saved.make][saved.model];
      if (saved.year && years.map(String).indexOf(String(saved.year)) === -1) return null;
      return saved;
    } catch (e) { return null; }
  }

  function rememberVehicle(make, model, year) {
    try {
      if (make) localStorage.setItem('abm:vehicle', JSON.stringify({ make: make, model: model, year: year }));
      else localStorage.removeItem('abm:vehicle');
    } catch (e) { /* Browsing still works when storage is unavailable. */ }
    if (window.ABMShopping) window.ABMShopping.remember({ make: make, model: model, year: year });
  }

  $$('[data-saved-vehicle]').forEach(function (bar) {
    if (!window.fetch) return;
    loadVehicles(bar.getAttribute('data-src')).then(function (json) {
      var saved = window.ABMShopping ? window.ABMShopping.getVehicle() : savedVehicle(json);
      if (!saved) return;
      var tag = [saved.year, saved.make, saved.model].filter(Boolean).join(' ');
      var link = $('[data-saved-vehicle-link]', bar);
      link.textContent = 'Shop ' + [saved.year, makeLabel(saved.make), saved.model].filter(Boolean).join(' ') + ' parts';
      link.href = vehicleURL(tag, bar.getAttribute('data-base'));
      bar.hidden = false;
    }).catch(function () {});
    on($('[data-clear-vehicle]', bar), 'click', function () {
      rememberVehicle('', '', '');
      bar.hidden = true;
      $$('[data-ymm-make]').forEach(function (select) {
        select.value = '';
        select.dispatchEvent(new Event('change'));
      });
      var search = $$('[data-predictive-input]').filter(function (input) { return input.offsetWidth; })[0];
      if (search) search.focus();
    });
  });

  function vehicleURL(tag, base, routes) {
    routes = routes || (window.ABM && window.ABM.vehicleCollections) || {};
    base = base || (window.ABM && window.ABM.routes && window.ABM.routes.allParts) || '/collections/just-pulled';
    var year = String(tag).match(/^(?:19|20)\d{2}\s+(.+)$/);
    var label = year ? year[1] : String(tag);
    var key = handleize(label);
    var aliases = { mercedes: 'mercedes-benz', 'mini-cooper': 'mini', ram: 'dodge', 'dodge-ram': 'dodge' };
    key = aliases[key] || key;
    if (routes[key]) return routes[key] + (year ? '/' + handleize(tag) : '');
    var parent = Object.keys(routes).filter(function (candidate) { return key.indexOf(candidate + '-') === 0; })
      .sort(function (a, b) { return b.length - a.length; })[0];
    return (parent ? routes[parent] : base) + '/' + handleize(tag);
  }

  // The yard hands customers a part's number as "R#30229". Shopify's search matches the bare
  // SKU every time but "R#" plus a new part's number only some of the time (2026-09-24: about
  // half the tries for parts a day old), so an R#, R #, #, R12345 or ABM-12345 lookup searches the number.
  function partQuery(term) {
    var t = String(term || '').trim();
    // The shared resolver must see the label: R# is an explicit SKU lookup,
    // whereas the same bare digits may also identify a donor stock number.
    if (window.ABMShopping) return t;
    var m = t.match(/^(?:r\s*#|#)\s*(\d{3,7})$/i) || t.match(/^r(\d{4,7})$/i) || t.match(/^abm\s*[-#]?\s*(\d{3,7})$/i);
    return m ? m[1] : t;
  }

  function productSearchURL(term, keywordOnly) {
    if (window.ABMShopping) return window.ABMShopping.searchURL(term, keywordOnly ? { vehicle: null } : {});
    var base = (window.ABM && window.ABM.routes && window.ABM.routes.search) || '/search';
    return base + '?type=product&q=' + encodeURIComponent(term) +
      '&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last' + (keywordOnly ? '&from=keyword' : '');
  }

  var searchRedirecting = false;
  if ($('[data-product-only-search]')) {
    var productSearch = new URL(window.location.href);
    // Leave the empty search landing page alone. Old links should use the same product
    // scope as the form: sold-out parts last, never hidden ("hide" also dropped every
    // ship:pickup-only part). The query is kept as typed, except an R# becomes its number.
    if ((productSearch.searchParams.get('q') || '').trim()) {
      var asked = productSearch.searchParams.get('q');
      if (partQuery(asked) !== asked.trim()) {
        productSearch.searchParams.set('q', partQuery(asked));
        searchRedirecting = true;
      }
      ['type', 'options[unavailable_products]'].forEach(function (key) {
        var value = key === 'type' ? 'product' : 'last';
        if (productSearch.searchParams.get(key) !== value || productSearch.searchParams.getAll(key).length !== 1) {
          productSearch.searchParams.set(key, value);
          searchRedirecting = true;
        }
      });
      if (searchRedirecting) {
        productSearch.searchParams.delete('page');
        window.location.replace(productSearch.toString());
      }
    }
  }

  var PHOTO = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" fill="none" stroke="currentColor" stroke-width="1.4"/><circle cx="8.5" cy="10" r="1.6" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="m4 17 5-4.5 4 3.2 3-2.4 4 3.4" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';

  /* ------------------------------------------- dialog focus management */
  /* `role="dialog" aria-modal="true"` is a promise: focus enters the dialog, stays
     inside while it is open, and returns to whatever opened it. Neither drawer kept
     it. Tab walked straight out into the page behind the scrim — and because the
     background paints *under* the overlay, the focus ring went invisible, so a
     keyboard user was left activating controls they could not see. Closing then
     dropped focus to <body>, restarting the next Tab at the top of the document. */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), ' +
    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var openDialog = null;     // panel currently holding focus
  var dialogTrigger = null;  // control to hand focus back to on close

  function visibleFocusable(root) {
    return $$(FOCUSABLE, root).filter(function (el) {
      return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
    });
  }

  // Only regions that can never contain a drawer, so this cannot inert a live dialog.
  function backgroundRegions(panel) {
    return $$('#MainContent, .footer').filter(function (el) { return !el.contains(panel); });
  }

  function trapFocus(panel, trigger) {
    if (!panel) return;
    dialogTrigger = trigger || dialogTrigger || document.activeElement;
    openDialog = panel;
    backgroundRegions(panel).forEach(function (el) {
      el.inert = true;
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function releaseFocus() {
    if (!openDialog) return;
    backgroundRegions(openDialog).forEach(function (el) {
      el.inert = false;
      el.removeAttribute('aria-hidden');
    });
    openDialog = null;
    var back = dialogTrigger;
    dialogTrigger = null;
    if (back && document.contains(back)) back.focus();
  }

  on(document, 'keydown', function (e) {
    if (e.key !== 'Tab' || !openDialog) return;
    var items = visibleFocusable(openDialog);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (!openDialog.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* --------------------------------------------------------- menu drawer */
  var drawer = $('[data-drawer]');
  function closeDrawer() {
    // Guarded on the open state so a stray Escape cannot release another dialog's trap.
    if (!drawer || !drawer.hasAttribute('open')) return;
    drawer.removeAttribute('open');
    document.body.style.overflow = '';
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    releaseFocus();
  }
  $$('[data-drawer-open]').forEach(function (b) {
    on(b, 'click', function () {
      if (!drawer) return;
      drawer.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      b.setAttribute('aria-expanded', 'true');
      var panel = drawer.querySelector('.drawer__panel') || drawer;
      trapFocus(panel, b);
      var first = visibleFocusable(panel)[0];
      if (first) first.focus();
    });
  });
  $$('[data-drawer-close]').forEach(function (b) { on(b, 'click', closeDrawer); });

  on(document, 'keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeCart();
    $$('[data-predictive-results]').forEach(hidePredictive);
    $$('details[data-nav-item][open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  on(document, 'click', function (e) {
    $$('details[data-nav-item][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
    $$('[data-predictive]').forEach(function (wrap) {
      if (!wrap.contains(e.target)) hidePredictive($('[data-predictive-results]', wrap));
    });
  });

  /* ---------------------------------------------------- predictive search */
  // With ~9,000 one-off parts, finding the part IS the funnel. Query SKU as
  // well as title so a stock number off the part's tag lands straight on it.
  // aria-selected is what the existing .predictive__item[aria-selected="true"] rule
  // styles, and what tells a screen reader which suggestion is current.
  function markSelected(panel, el) {
    $$('.predictive__item', panel).forEach(function (item) {
      item.setAttribute('aria-selected', item === el ? 'true' : 'false');
    });
  }

  function announce(wrap, count, term) {
    var status = $('[data-predictive-status]', wrap);
    if (!status) return;
    status.textContent = count
      ? count + (count === 1 ? ' part matches ' : ' parts match ') + '"' + term + '"'
      : 'No suggestions for "' + term + '". Try the full parts search.';
  }

  function hidePredictive(panel) {
    if (!panel) return;
    var input = $('[data-predictive-input]', panel.parentNode);
    // Arrow keys move real focus onto result links. Hiding the panel while focus is
    // still inside it strands focus on an unrenderable node, so hand it back first.
    if (input && panel.contains(document.activeElement)) input.focus();
    panel.hidden = true;
    if (input) input.setAttribute('aria-expanded', 'false');
  }

  function renderPredictive(data, term) {
    var resolved = window.ABMShopping ? window.ABMShopping.resolve(term) : null;
    var products = ((data.resources && data.resources.results && data.resources.results.products) || [])
      .filter(function (p) {
        return p.available !== false && (!resolved || window.ABMShopping.matchesSearch({ sku: ((p.variants || [])[0] || {}).sku, stock: p.stock, codes: p.codes, type: p.type, fitment: p.fitment }, resolved));
      });
    var allLink = '<a class="predictive__all" href="' + esc(productSearchURL(term)) + '">See all parts for "' + esc(term) + '" &rarr;</a>';
    if (!products.length) {
      return '<div class="predictive__empty">' +
        '<b>No suggestions for "' + esc(term) + '"</b>' +
        'Try the full parts search, or call the yard for help.' +
        '</div>' + allLink;
    }
    var candidate = resolved ? resolved.vehicle : null;
    var rows = products.map(function (p) {
      var v = (p.variants && p.variants[0]) || {};
      var price = parseFloat(p.price);
      var sku = v.sku ? 'Part ID <b>' + esc(v.sku) + '</b>' : '';
      var type = p.type ? esc(p.type) : '';
      var meta = [type, sku, p.stock ? 'Stock # ' + esc(p.stock) : ''].filter(Boolean).join(' &middot; ');
      if (window.ABMShopping) {
        if (candidate && window.ABMShopping.matchingRows(p.fitment || [], candidate).length) {
          meta += ' &middot; Application: ' + esc([candidate.year, candidate.make, candidate.model].filter(Boolean).join(' ')) + ' &middot; verify options';
        }
      }
      var thumb = p.featured_image && p.featured_image.url
        ? '<img src="' + esc(p.featured_image.url) + '" alt="" loading="lazy">'
        : PHOTO;
      var productURL = new URL(p.url, window.location.origin);
      if (candidate) productURL.searchParams.set('abm_vehicle', [candidate.year, candidate.make, candidate.model].filter(Boolean).join(' '));
      return '<a class="predictive__item" role="option" aria-selected="false" href="' + esc(productURL.pathname + productURL.search) + '">' +
        '<span class="predictive__thumb">' + thumb + '</span>' +
        '<span><span class="predictive__title">' + esc(p.title) + '</span>' +
        (meta ? '<span class="predictive__meta">' + meta + '</span>' : '') + '</span>' +
        '<span class="predictive__price">' + esc(isNaN(price) ? '' : money(Math.round(price * 100))) + '</span>' +
        '</a>';
    }).join('');

    // The listbox wraps only the options: the heading and the "see all" link are not
    // options, and a listbox containing non-option children is an invalid structure.
    return '<div class="predictive__head">Parts</div>' +
      '<div class="predictive__list" role="listbox" aria-label="Part suggestions">' + rows + '</div>' +
      allLink;
  }

  $$('[data-predictive]').forEach(function (wrap) {
    var input = $('[data-predictive-input]', wrap);
    var panel = $('[data-predictive-results]', wrap);
    var body = $('[data-predictive-body]', wrap);
    on($('form', wrap), 'submit', function (e) {
      if (!input) return;
      input.value = partQuery(input.value);
      if (!input.value) {
        e.preventDefault();
        hidePredictive(panel);
        input.focus();
        var status = $('[data-predictive-status]', wrap);
        if (status) status.textContent = 'Enter a part name, vehicle, stock number, Part ID, or interchange number.';
      } else if (window.ABMShopping) {
        e.preventDefault();
        window.ABMShopping.ready.then(function () { window.location.href = productSearchURL(input.value); });
      }
    });
    if (!input || !panel || !window.fetch) return;

    var timer = null;
    var lastTerm = '';
    var renderedTerm = '';
    var revision = 0;
    on(document, 'abm:scope', function () { lastTerm = ''; renderedTerm = ''; revision++; hidePredictive(panel); });

    function lookup() {
      var term = input.value.trim();
      if (term.length < 2 && !/^\d$/.test(term)) { hidePredictive(panel); return; }
      if (term === lastTerm) {
        // Refocusing or clearing and retyping a query should reopen its results.
        // A pending request may still have the previous query's markup in the panel.
        if (renderedTerm === term) {
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      lastTerm = term;
      var requestRevision = ++revision;

      var url = (window.ABM.routes.predictive || '/search/suggest') + '.json' +
        '?q=' + encodeURIComponent(partQuery(term)) +
        '&resources[type]=product&resources[limit]=8' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.sku,vendor,tag';

      // The suggest endpoint fails occasionally and the same query succeeds straight
      // after — the audit hit it twice in one session. One retry costs a few hundred
      // milliseconds and turns a dead dropdown into a working one; a second would just
      // be stubborn. A failure after that closes the panel rather than leaving a stale
      // list under a new query, and lastTerm is cleared so the next keystroke retries
      // instead of being suppressed as a duplicate.
      function attempt(retriesLeft) {
        (window.ABMShopping ? window.ABMShopping.ready : Promise.resolve()).then(function () {
          if (window.ABMShopping) {
            return fetch(productSearchURL(term) + '&view=suggestions', { headers: { Accept: 'text/html' } }).then(function (r) {
              if (!r.ok) throw new Error('Search unavailable');
              return r.text();
            }).then(function (html) {
              var parsed = new DOMParser().parseFromString(html, 'text/html');
              var json = parsed.querySelector('[data-shopping-suggestions]');
              if (!json) throw new Error('Search response missing');
              return JSON.parse(json.textContent);
            });
          }
          return fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('suggest ' + r.status);
            return r.json();
          });
        })
          .then(function (data) {
            if (input.value.trim() !== term || requestRevision !== revision) return;
            body.innerHTML = renderPredictive(data, term);
            renderedTerm = term;
            announce(wrap, $$('.predictive__item', body).length, term);
            panel.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          })
          .catch(function () {
            if (requestRevision !== revision) return;
            if (retriesLeft > 0) {
              setTimeout(function () { attempt(retriesLeft - 1); }, 350);
              return;
            }
            lastTerm = '';
            hidePredictive(panel);
          });
      }
      attempt(1);
    }

    on(input, 'input', function () {
      clearTimeout(timer);
      timer = setTimeout(lookup, 180);
    });
    on(input, 'focus', lookup);

    on(input, 'keydown', function (e) {
      var items = $$('.predictive__item, .predictive__all', panel);
      if (!items.length || panel.hidden) return;
      var current = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[current + 1] || items[0]).focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (items[current - 1] || input).focus(); }
    });
    on(panel, 'focusin', function (e) {
      markSelected(panel, e.target.classList.contains('predictive__item') ? e.target : null);
    });
    on(panel, 'keydown', function (e) {
      var items = $$('.predictive__item, .predictive__all', panel);
      var current = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[current + 1] || items[0]).focus(); }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (current <= 0) input.focus(); else items[current - 1].focus();
      }
    });
  });


  /* ------------------------------------------------- shop by vehicle (YMM) */
  // Data is a static theme asset built from the catalog's own year/make/model
  // tags, so the picker can never offer a vehicle we have no parts for.
  //
  // Submitting navigates to the exact tag filter — /collections/all/2014-subaru-legacy —
  // the same route the collection sidebar facet builds. It used to hand the three values
  // to /search as one keyword string, which is an OR match: "2014 Subaru Legacy" returned
  // 1,000 results padded out with Dodge, Honda and Ford parts, against 102 that actually
  // fit. The section promises "only the parts we actually have for it", so it has to be
  // the filter and not the search index.
  $$('[data-ymm]').forEach(function (form) {
    var makeSel = $('[data-ymm-make]', form);
    var modelSel = $('[data-ymm-model]', form);
    var yearSel = $('[data-ymm-year]', form);
    var submit = $('[data-ymm-submit]', form);
    var hint = $('[data-ymm-hint]', form);
    if (!makeSel || !window.fetch) return;

    var base = form.getAttribute('data-base') || '/collections/all';

    var data = null;
    var makeOnly = {};          // makes the catalogue can filter on without a model
    var defaultHint = hint ? hint.textContent : '';

    function fill(sel, values, placeholder) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>' +
        values.map(function (v) {
          return '<option value="' + esc(v) + '">' + esc(makeLabel(v)) + '</option>';
        }).join('');
    }

    loadVehicles(form.getAttribute('data-src'))
      .then(function (json) {
        data = json.makes || {};
        (json.make_only || Object.keys(data)).forEach(function (m) { makeOnly[m] = true; });
        fill(makeSel, Object.keys(data), 'Choose a make');
        var saved = savedVehicle(json);
        if (saved) {
          makeSel.value = saved.make;
          makeSel.dispatchEvent(new Event('change'));
          if (saved.model) {
            modelSel.value = saved.model;
            modelSel.dispatchEvent(new Event('change'));
            yearSel.value = saved.year || '';
          }
          sync();
        }
      })
      .catch(function () {
        if (hint) hint.textContent = 'Vehicle list unavailable — use the search box above, or call the yard.';
      });

    on(makeSel, 'change', function () {
      var make = makeSel.value;
      modelSel.disabled = !make;
      yearSel.disabled = true;
      yearSel.innerHTML = '<option value="">Any year</option>';
      if (!make || !data[make]) {
        modelSel.innerHTML = '<option value="">Choose a model</option>';
      } else {
        fill(modelSel, Object.keys(data[make]), 'Choose a model');
      }
      sync();
    });

    on(modelSel, 'change', function () {
      var years = (data[makeSel.value] || {})[modelSel.value] || [];
      yearSel.disabled = !years.length;
      fill(yearSel, years.slice().reverse(), 'Any year');
      sync();
    });

    on(yearSel, 'change', sync);

    // One tag, exactly as CoreYard writes it onto the product: "2014 Subaru Legacy",
    // "Subaru Legacy" or "Subaru". A year without a model has no tag of its own —
    // /collections/all/2014-subaru redirects away — so the year only counts once a
    // model is chosen, which is also the order the selects unlock in.
    function chosen() {
      if (makeSel.value && modelSel.value && yearSel.value) {
        return yearSel.value + ' ' + makeSel.value + ' ' + modelSel.value;
      }
      if (makeSel.value && modelSel.value) return makeSel.value + ' ' + modelSel.value;
      return makeSel.value || '';
    }

    on(form, 'submit', function (e) {
      var tag = chosen();
      if (!tag) return;
      e.preventDefault();
      submit.disabled = true;
      rememberVehicle(makeSel.value, modelSel.value, yearSel.value);
      window.location.href = vehicleURL(tag, base);
    });

    function sync() {
      // Year alone is useless; require at least a make. A handful of makes are tagged
      // only alongside a model — "Mercedes C-Class" exists, plain "Mercedes" does not —
      // and vehicles.json says which, so the button waits for a model rather than
      // sending the shopper to a filter the catalogue would drop.
      var needsModel = makeSel.value && !makeOnly[makeSel.value];
      submit.disabled = !makeSel.value || (needsModel && !modelSel.value);
      if (hint) hint.textContent = (needsModel && !modelSel.value)
        ? 'Choose a model to see ' + makeLabel(makeSel.value) + ' parts.'
        : defaultHint;
    }
  });

  /* ------------------------------------------- vehicle-aware search (H-01) */
  // Shopify search is an OR match: "Subaru Legacy" returns 515 results whose tail is other
  // makes entirely, against 102 parts that actually fit. The tag filter is the honest
  // answer, and vehicles.json already says which vehicles have one.
  //
  // A query that is ONLY a vehicle is replaced by that vehicle's filter (location.replace,
  // so Back still returns to wherever the shopper came from). A query that names a vehicle
  // plus other words keeps its results and gets a link above them — those other words are
  // the part they came for, and the filter alone would throw them away.
  $$('[data-vehicle-route]').forEach(function (mount) {
    var terms = (mount.getAttribute('data-terms') || '').trim();
    var base = mount.getAttribute('data-base') || '/collections/all';
    // Numeric Part IDs can also be model names (e.g. Chrysler 300). Keep those
    // as keyword searches unless the shopper supplies vehicle words as well.
    if (!terms || /^\d+$/.test(terms) || !window.fetch || searchRedirecting) return;

    // "Search all parts by keyword instead" on the filtered page links back here. Without
    // this the two would bounce off each other forever, because the query that sent the
    // shopper to the filter is the same query they just asked to see keyword results for.
    var askedForKeywords =
      new URLSearchParams(window.location.search || '').get('from') === 'keyword';

    loadVehicles(mount.getAttribute('data-src'))
      .then(function (json) {
        var data = json.makes || {};
        var makeOnly = {};
        (json.make_only || Object.keys(data)).forEach(function (m) { makeOnly[m] = true; });

        var words = terms.split(/\s+/).filter(Boolean);
        var used = [];

        // Pull out a 4-digit year that looks like a model year, wherever it sits.
        var year = '', yearAt = -1;
        for (var i = 0; i < words.length; i++) {
          if (/^(19|20)\d{2}$/.test(words[i])) { year = words[i]; yearAt = i; used.push(i); break; }
        }

        // Longest make first, so "Land Rover" is not read as a make called "Land".
        function matchAt(list, from) {
          var best = null;
          list.forEach(function (name) {
            var parts = name.toLowerCase().split(' ');
            if (parts.length > words.length - from) return;
            for (var k = 0; k < parts.length; k++) {
              if (used.indexOf(from + k) !== -1) return;
              if (words[from + k].toLowerCase().replace(/[^a-z0-9]/g, '') !==
                  parts[k].replace(/[^a-z0-9]/g, '')) return;
            }
            if (!best || parts.length > best.span) best = { name: name, span: parts.length };
          });
          return best;
        }

        var makes = Object.keys(data).sort(function (a, b) { return b.length - a.length; });
        var make = null, makeAt = -1;
        for (var w = 0; w < words.length && !make; w++) {
          if (used.indexOf(w) !== -1) continue;
          var hit = matchAt(makes, w);
          if (hit) { make = hit; makeAt = w; }
        }

        // People type the model on its own — the hero placeholder suggests "2012 Silverado
        // alternator". A model is only a vehicle when exactly one make has it: "Silverado"
        // is a Chevrolet and nothing else, while "1500" is a Chevrolet, a GMC and a Dodge,
        // and guessing between them would be the same wrong-vehicle answer we are fixing.
        var soleMake = null;
        if (!make) {
          var owners = {};
          Object.keys(data).forEach(function (mk) {
            Object.keys(data[mk]).forEach(function (md) {
              var key = md.toLowerCase();
              (owners[key] = owners[key] || []).push(mk);
            });
          });
          var names = Object.keys(owners).filter(function (k) { return owners[k].length === 1; })
            .sort(function (a, b) { return b.length - a.length; });
          for (var u = 0; u < words.length && !soleMake; u++) {
            if (used.indexOf(u) !== -1) continue;
            var mfound = matchAt(names, u);
            if (!mfound) continue;
            var owner = owners[mfound.name.toLowerCase()][0];
            // Keep the catalogue's own casing rather than the shopper's.
            var real = Object.keys(data[owner]).filter(function (md) {
              return md.toLowerCase() === mfound.name.toLowerCase();
            })[0];
            soleMake = { make: owner, model: real, span: mfound.span, at: u };
          }
          if (!soleMake) return;
          make = { name: soleMake.make, span: 0 };
          makeAt = soleMake.at;
        }
        for (var m = 0; m < make.span; m++) used.push(makeAt + m);

        var model = null, modelAt = -1;
        if (soleMake) {
          model = { name: soleMake.model, span: soleMake.span };
          modelAt = soleMake.at;
        } else {
          var models = Object.keys(data[make.name] || {}).sort(function (a, b) { return b.length - a.length; });
          for (var v = 0; v < words.length && !model; v++) {
            if (used.indexOf(v) !== -1) continue;
            var mhit = matchAt(models, v);
            if (mhit) { model = mhit; modelAt = v; }
          }
        }
        if (model) { for (var n = 0; n < model.span; n++) used.push(modelAt + n); }

        // A year only narrows a model, and only one the catalogue actually tagged. A year we
        // do not stock stays in the query as a leftover word, so the shopper gets the link
        // and their own results rather than being moved somewhere that quietly ignored it.
        function dropYear() {
          year = '';
          used = used.filter(function (ix) { return ix !== yearAt; });
        }
        if (year && model) {
          var yrs = (data[make.name] || {})[model.name] || [];
          if (yrs.indexOf(parseInt(year, 10)) === -1) dropYear();
        } else if (year) {
          dropYear();
        }

        var tag = model
          ? (year ? year + ' ' + make.name + ' ' + model.name : make.name + ' ' + model.name)
          : ((makeOnly[make.name] || ((window.ABM || {}).vehicleCollections || {})[handleize(make.name)]) ? make.name : '');
        if (!tag) return;

        var url = vehicleURL(tag, base);
        var leftover = words.filter(function (_, ix) { return used.indexOf(ix) === -1; });

        if (!leftover.length && !askedForKeywords) {
          // The query was the vehicle and nothing else — the filter IS the answer.
          window.location.replace(url + '?from=search&q=' + encodeURIComponent(terms));
          return;
        }

        mount.className = 'vehicle-route';
        mount.innerHTML =
          '<p><b>Looking for ' + esc(tag) + ' parts?</b> These keyword results include parts ' +
          'for other vehicles. <a href="' + esc(url) + '">See only parts that fit the ' +
          esc(tag) + '</a>, then narrow by type.</p>';
      })
      .catch(function () { /* keyword results stand on their own */ });
  });

  /* Arrival note for a search that was answered with a vehicle filter, so the shopper is
     told what happened instead of silently finding themselves somewhere else. */
  (function () {
    var params = new URLSearchParams(window.location.search || '');
    if (params.get('from') !== 'search') return;
    var main = $('#MainContent') || document.body;
    var host = $('.page-width', main) || main;
    var said = document.createElement('div');
    said.className = 'vehicle-route';
    var asked = params.get('q') || '';
    said.innerHTML = '<p>Showing parts that fit this vehicle' +
      (asked ? ', for your search &ldquo;' + esc(asked) + '&rdquo;' : '') +
      '. <a href="' + esc(productSearchURL(asked, true)) + '">Search all parts by keyword instead</a>.</p>';
    host.insertBefore(said, host.firstChild);
  })();

  /* ------------------------------------- collection vehicle facet (YMM) */
  // Same vehicles.json the home-page picker uses, driving Shopify's native tag
  // filtering — /collections/all/ford+ford-ranger — so narrowing needs no filter
  // app. Make/model/year cascade client-side; only "Find parts" navigates, so
  // picking a vehicle costs one page load instead of three.
  $$('[data-ymm-facet]').forEach(function (root) {
    var makeSel = $('[data-ymmf-make]', root);
    var modelSel = $('[data-ymmf-model]', root);
    var yearSel = $('[data-ymmf-year]', root);
    var applyBtn = $('[data-ymmf-apply]', root);
    var clearWrap = $('[data-ymmf-clear]', root);
    var clearLink = $('[data-ymmf-clear-link]', root);
    var note = $('[data-ymmf-note]', root);
    if (!makeSel || !modelSel || !yearSel || !applyBtn || !window.fetch) return;

    var base = root.getAttribute('data-base') || '';
    var sort = root.getAttribute('data-facet-sort') || '';
    var view = root.getAttribute('data-facet-view') || '';
    var current = (root.getAttribute('data-tags') || '').split('~').filter(Boolean);
    var fixedVehicle = root.getAttribute('data-fixed-vehicle') || '';
    var allUrl = root.getAttribute('data-all-url') || base;
    var makes = [];
    var data = null;
    var makeOnly = {};
    var hasActive = false;
    var busy = false;

    function fill(sel, values, placeholder, selected) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>' +
        values.map(function (v) {
          return '<option value="' + esc(v) + '"' + (v === selected ? ' selected' : '') +
            '>' + esc(makeLabel(v)) + '</option>';
        }).join('');
    }

    // "1994 Ford Ranger" / "Ford Ranger" / "Ford" -> parts, if we stock that vehicle.
    // Longest make first, so "Land Rover" is not mistaken for a make called "Land".
    function parseVehicle(tag) {
      if (!data) return null;
      var year = '';
      var rest = tag;
      var m = /^(\d{4})\s+(.+)$/.exec(tag);
      if (m) { year = m[1]; rest = m[2]; }
      for (var i = 0; i < makes.length; i++) {
        var make = makes[i];
        if (rest === make) return year ? null : { make: make, model: '', year: '' };
        if (rest.indexOf(make + ' ') === 0) {
          var model = rest.slice(make.length + 1);
          if (data[make][model]) return { make: make, model: model, year: year };
        }
      }
      return null;
    }

    // fixedVehicle is set when the collection itself is locked to a vehicle by a Shopify
    // collection rule (e.g. /collections/ford-parts to "Ford") rather than by a tag path
    // segment this facet controls, so leaving that vehicle has nowhere to go on THIS
    // collection — every other vehicle, or none, would show zero results here forever.
    // withinFixed says whether a candidate tag is still that vehicle or a narrower cut of
    // it (a model or year within the fixed make, or a year within the fixed model).
    function withinFixed(tag) {
      if (!fixedVehicle) return true;
      if (!tag) return false;
      var pattern = fixedVehicle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return new RegExp('(^|\\s)' + pattern + '($|\\s)').test(tag);
    }

    // Keep every non-vehicle tag already on the URL, swap in the chosen vehicle. Once the
    // choice leaves the collection's own fixed vehicle, the fixed collection can't show it
    // (or "all vehicles" on Clear) — only /collections/all can, so the base switches too.
    function urlFor(vehicleTag) {
      // fixedVehicle is excluded by exact match, not just parseVehicle: a collection can
      // be locked to a vehicle vehicles.json no longer lists (sold through, say), and
      // parseVehicle would then fail to recognise it and leave it stuck in "keep" forever.
      var keep = current.filter(function (t) { return !parseVehicle(t) && t !== fixedVehicle; });
      var tags = keep.concat(vehicleTag ? [vehicleTag] : []).map(handleize);
      var useBase = (fixedVehicle && !withinFixed(vehicleTag)) ? allUrl : base;
      var query = new URLSearchParams();
      if (sort) query.set('sort_by', sort);
      if (view) query.set('view', view);
      var destination = useBase + (tags.length ? '/' + tags.join('+') : '');
      if (vehicleTag && keep.length === 0 && (useBase === allUrl || useBase === '/collections/all')) destination = vehicleURL(vehicleTag, allUrl);
      return destination + (query.toString() ? '?' + query.toString() : '');
    }

    function chosen() {
      if (makeSel.value && modelSel.value && yearSel.value) {
        return yearSel.value + ' ' + makeSel.value + ' ' + modelSel.value;
      }
      if (makeSel.value && modelSel.value) return makeSel.value + ' ' + modelSel.value;
      if (makeSel.value) return makeSel.value;
      return '';
    }

    function sync() {
      // Some makes have model tags but no standalone make tag. Shopify silently
      // drops an unknown tag, so require a model just as the homepage picker does.
      var needsModel = makeSel.value && !makeOnly[makeSel.value] && !modelSel.value;
      applyBtn.disabled = busy || !data || needsModel || !(makeSel.value || hasActive);
      if (note) {
        note.hidden = !needsModel;
        note.textContent = needsModel ? 'Choose a model to see ' + makeLabel(makeSel.value) + ' parts.' : '';
      }
    }

    function models(make) { return Object.keys(data[make]).sort(); }
    function years(make, model) {
      return ((data[make] || {})[model] || []).slice().reverse().map(String);
    }

    on(makeSel, 'change', function () {
      var make = makeSel.value;
      yearSel.innerHTML = '<option value="">Any year</option>';
      yearSel.disabled = true;
      if (!make || !data || !data[make]) {
        modelSel.innerHTML = '<option value="">Any model</option>';
        modelSel.disabled = true;
      } else {
        fill(modelSel, models(make), 'Any model', '');
        modelSel.disabled = false;
      }
      sync();
    });

    on(modelSel, 'change', function () {
      var list = (data && modelSel.value) ? years(makeSel.value, modelSel.value) : [];
      fill(yearSel, list, 'Any year', '');
      yearSel.disabled = !list.length;
      sync();
    });

    on(yearSel, 'change', sync);

    on(applyBtn, 'click', function () {
      if (busy || applyBtn.disabled) return;
      busy = true;
      applyBtn.disabled = true;
      rememberVehicle(makeSel.value, modelSel.value, yearSel.value);
      window.location.href = urlFor(chosen());
    });

    loadVehicles(root.getAttribute('data-src'))
      .then(function (json) {
        data = json.makes || {};
        // Longest first for prefix matching; the <select> itself stays alphabetical.
        (json.make_only || Object.keys(data)).forEach(function (make) { makeOnly[make] = true; });
        makes = Object.keys(data).sort(function (a, b) { return b.length - a.length; });

        var active = null;
        for (var i = 0; i < current.length && !active; i++) active = parseVehicle(current[i]);
        // A fixed-vehicle collection (see facets-tags.liquid) still needs a way back to
        // "all vehicles" even when its vehicle tag doesn't parse against this store's
        // current vehicles.json — a model that has since sold through, say — so Clear
        // does not depend on parseVehicle succeeding, only on fixedVehicle being set.
        hasActive = Boolean(active) || Boolean(fixedVehicle);
        // A saved vehicle pre-fills controls only on collections without a fixed vehicle.
        var selected = active || (fixedVehicle ? null : savedVehicle(json));

        fill(makeSel, Object.keys(data).sort(), 'Any make', selected ? selected.make : '');
        if (selected) {
          fill(modelSel, models(selected.make), 'Any model', selected.model);
          modelSel.disabled = false;
          if (selected.model) {
            fill(yearSel, years(selected.make, selected.model), 'Any year', String(selected.year || ''));
            yearSel.disabled = false;
          }
        }
        if ((active || fixedVehicle) && clearWrap && clearLink) {
          clearLink.href = urlFor('');
          clearWrap.hidden = false;
        }
        sync();
      })
      .catch(function () {
        if (note) {
          note.hidden = false;
          note.textContent = 'Vehicle list unavailable — use the search box, or call the yard.';
        }
      });
  });

  /* --------------------------------------------------- related parts */
  function relatedText(value) {
    return typeof value === 'string' ? value.trim().replace(/\s+/g, ' ').toLowerCase() : '';
  }

  function relatedFitment(value) {
    var rows;
    try { rows = JSON.parse(value); } catch (e) { return []; }
    if (!Array.isArray(rows)) return [];
    return rows.reduce(function (valid, row) {
      if (!row || typeof row.years !== 'string') return valid;
      var years = row.years.trim().match(/^(\d{4})(?:\s*[-–]\s*(\d{4}))?$/);
      var make = relatedText(row.make);
      var model = relatedText(row.model);
      if (!years || !make || !model) return valid;
      var low = Number(years[1]);
      var high = Number(years[2] || years[1]);
      if (low < 1900 || high > 2100 || low > high) return valid;
      // Unknown/malformed option data cannot establish a match. Empty notes are valid.
      if (typeof row.note !== 'string') return valid;
      valid.push({ make: make, model: model, low: low, high: high, note: relatedText(row.note) });
      return valid;
    }, []);
  }

  $$('[data-related]').forEach(function (root) {
    var exclude = root.getAttribute('data-related-exclude');
    var type = relatedText(root.getAttribute('data-related-type'));
    var fitment = relatedFitment(root.getAttribute('data-related-fitment'));
    var grid = $('[data-related-grid]', root);
    if (!type || !fitment.length || !grid || !window.fetch) return;
    var urls = $$('[data-related-source]', root).map(function (source) {
      return source.getAttribute('data-related-source');
    }).filter(function (url, index, all) { return url && all.indexOf(url) === index; }).slice(0, 3);

    // At most three model/type queries, 50 candidates each. Missing a possible match
    // is preferable to downloading the catalog or filling the row with unrelated stock.
    Promise.all(urls.map(function (url) {
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) {
          var holder = document.createElement('div');
          holder.innerHTML = html;
          return $$('template[data-related-candidate]', holder);
        })
        .catch(function () { return []; });
    })).then(function (batches) {
      var seen = {};
      var cards = [];
      batches.forEach(function (candidates) {
        candidates.forEach(function (candidate) {
          var id = candidate.getAttribute('data-product-id');
          if (!id || id === exclude || seen[id] || cards.length >= 4) return;
          if (candidate.getAttribute('data-available') !== 'true') return;
          if (relatedText(candidate.getAttribute('data-type')) !== type) return;
          var matches = relatedFitment(candidate.getAttribute('data-fitment')).some(function (other) {
            return fitment.some(function (row) {
              // Equal option notes conservatively reject different engines, sides,
              // VIN restrictions, etc. This is relevance, not verified interchange.
              return row.make === other.make && row.model === other.model &&
                row.low <= other.high && other.low <= row.high && row.note === other.note;
            });
          });
          var card = candidate.content && $('.card', candidate.content);
          if (!matches || !card || card.getAttribute('data-product-id') !== id) return;
          seen[id] = true;
          cards.push(card);
        });
      });
      if (!cards.length) return;
      grid.innerHTML = '';
      cards.forEach(function (card) { grid.appendChild(card); });
      if (window.ABMShopping) window.ABMShopping.applyFitment(root);
      root.hidden = false;
    }).catch(function () { /* no weak fallback on an invalid response */ });
  });

  /* ------------------------------------------------------------ gallery */
  $$('[data-gallery]').forEach(function (gallery) {
    var main = $('[data-gallery-main]', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    if (!main || !thumbs.length) return;

    function select(btn) {
      var src = btn.getAttribute('data-full');
      if (src) {
        // The first photo ships a width srcset; a bare src swap would leave it winning.
        if (main.hasAttribute('srcset')) {
          main.srcset = [600, 800, 1000, 1400].map(function (w) { return src.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w'; }).join(', ');
        }
        main.src = src; main.alt = btn.getAttribute('data-alt') || '';
      }
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(t === btn)); });
    }
    thumbs.forEach(function (t) {
      on(t, 'click', function () { select(t); });
      on(t, 'keydown', function (e) {
        var i = thumbs.indexOf(t);
        if (e.key === 'ArrowRight' && thumbs[i + 1]) { thumbs[i + 1].focus(); select(thumbs[i + 1]); }
        if (e.key === 'ArrowLeft' && thumbs[i - 1]) { thumbs[i - 1].focus(); select(thumbs[i - 1]); }
      });
    });
  });

  /* ---------------------------------------------------------- quantity */
  function requestedQuantity(input, minimum) {
    if (input && input.hasAttribute('data-single-quantity')) return 1;
    var max = input ? parseInt(input.getAttribute('max'), 10) : 1;
    // No max means Shopify permits untracked inventory or continued selling.
    if (!Number.isFinite(max)) max = Infinity;
    var value = input ? Math.floor(Number(input.value)) : 1;
    if (!Number.isFinite(value)) value = minimum;
    return Math.min(max, Math.max(minimum, value));
  }

  $$('[data-vin]').forEach(function (input) {
    on(input, 'input', function () { input.value = input.value.toUpperCase().replace(/\s/g, ''); });
  });

  $$('[data-qty]').forEach(function (wrap) {
    var input = $('input', wrap);
    if (!input) return;
    var min = Number(input.getAttribute('min') || '1');
    function syncButtons() {
      var value = Number(input.value);
      var max = parseInt(input.getAttribute('max'), 10);
      $$('button', wrap).forEach(function (btn) {
        btn.disabled = btn.getAttribute('data-qty-step') === 'down' ? value <= min : value >= max;
      });
    }
    on(input, 'input', syncButtons);
    on(input, 'change', function () {
      input.value = requestedQuantity(input, min);
      syncButtons();
    });
    $$('button', wrap).forEach(function (btn) {
      on(btn, 'click', function () {
        var step = btn.getAttribute('data-qty-step') === 'down' ? -1 : 1;
        var value = Math.floor(Number(input.value));
        input.value = (Number.isFinite(value) ? value : min) + step;
        input.value = requestedQuantity(input, min);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    syncButtons();
  });

  /* ------------------------------------------------------ facet filters */
  $$('[data-mobile-filters]').forEach(function (filters) {
    var smallScreen = window.matchMedia('(max-width: 1100px)');
    function resizeFilters() { filters.open = !smallScreen.matches; }
    resizeFilters();
    smallScreen.addEventListener('change', resizeFilters);
  });
  if ($('[data-stock-collection]')) {
    var availabilityURL = new URL(window.location.href);
    // The native availability facet can lag the actual product availability and
    // calls buyable parts "out of stock". Use the product's live flag and
    // the explicit historical template instead, including for old bookmarked URLs.
    if (availabilityURL.searchParams.has('filter.v.availability')) {
      if (availabilityURL.searchParams.getAll('filter.v.availability').indexOf('0') !== -1) availabilityURL.searchParams.set('view', 'with-sold');
      availabilityURL.searchParams.delete('filter.v.availability');
      availabilityURL.searchParams.delete('page');
      window.location.replace(availabilityURL.toString());
    }
    $$('[data-stock-toggle]').forEach(function (link) {
      // Liquid chooses the collection and view: just-pulled excludes sold parts
      // by rule, so showing them must switch to all. Keep that destination while
      // carrying the shopper's filters and sort order into the new result set.
      var target = new URL(link.href);
      var params = new URLSearchParams(window.location.search);
      params.delete('view');
      params.delete('page');
      params.delete('filter.v.availability');
      target.searchParams.forEach(function (value, key) { params.set(key, value); });
      target.search = params.toString();
      link.href = target.toString();
    });
  }

  var facetForm = $('[data-facet-form]');
  if (facetForm) {
    on(facetForm, 'change', function () {
      if (facetForm.dataset.autoSubmit === 'false') return;
      facetForm.submit();
    });
  }
  $$('[data-sort]').forEach(function (sel) {
    // Only the <select> itself. A change event from any control inside a container
    // that also carried data-sort would bubble up and read .value off the container.
    if (sel.tagName !== 'SELECT') return;
    on(sel, 'change', function () {
      var url = new URL(window.location.href);
      if (sel.value === 'vehicle-match') url.searchParams.delete('sort_by');
      else url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* -------------------------------------------------------- cart drawer */
  var cartEl = null;

  function closeCart() {
    if (!cartEl || cartEl.hidden) return;
    cartEl.hidden = true;
    document.body.style.overflow = '';
    releaseFocus();
  }

  /* The hidden _ship line property (set by the product form from the product's ship:* tag
     at the moment a part is added) is still submitted with the line, but the drawer no
     longer trusts it back: a cart line predating that property has none, and a line's own
     product can be reclassified after it is already sitting in a shopper's cart. Either way
     reading it back showed "Free shipping" on a part that was never free.

     Instead every render of the drawer asks sections/cart-shipping-data.liquid — fetched
     fresh through the Section Rendering API — for each line's CURRENT classification, keyed
     by line.key the same way /cart.js keys its own items. That section renders
     'shipping-class' and 'shipping-group' from line.product exactly as main-cart.liquid does
     for the /cart page, so the drawer and the full cart page can never disagree. A request
     that fails, or a line the response doesn't mention, is treated as unknown shipping —
     never as free. */

  function fetchShippingData() {
    return fetch('/cart?section_id=cart-shipping-data', { headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('shipping data ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var tag = holder.querySelector('[data-cart-shipping]');
        if (!tag) throw new Error('shipping data missing');
        return JSON.parse(tag.textContent);
      });
  }

  /* Cart contents and their current shipping classification, fetched together. A failure
     to load the cart itself rejects — there is nothing safe to show. A failure to load
     shipping data degrades to null so the cart can still open, with every line and the
     cart-level notice shown as unknown rather than guessed. */
  function loadCart() {
    return Promise.all([
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        // Also shown verbatim if a submit's add.js succeeds but this refetch does not —
        // the part really was added, so this has to say so rather than "could not add".
        if (!r.ok) throw new Error("Added to cart, but couldn't load it — refresh the page to see your cart.");
        return r.json();
      }),
      fetchShippingData().catch(function () { return null; })
    ]).then(function (results) {
      return { cart: results[0], ship: results[1] };
    });
  }

  var UNKNOWN_SHIP_LABEL = '<span class="ship-line muted">Shipping &mdash; calculated at checkout</span>';

  /* Server-rendered markup for this exact line, straight from shipping-group.liquid style
     'line' — the same wording the /cart page shows. Never falls back to a guessed group. */
  function shipLabelMarkup(line, shipInfo) {
    var info = shipInfo && shipInfo.lines && shipInfo.lines[line.key];
    return (info && info.label) || UNKNOWN_SHIP_LABEL;
  }

  /* Shown only when shipping data could not be fetched at all — the cart-level notice is
     otherwise the exact HTML cart-shipping-data.liquid rendered from cart-delivery-notice,
     the same snippet the /cart page uses. This is deliberately a caution, not silence: an
     unreachable mixed-cart check must not read as "nothing to warn about". */
  var UNKNOWN_ALERT = '<div class="cart-alert">' +
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v10H3zM14 9h3.6l2.4 3v4h-6" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/></svg>' +
    '<div><b>Couldn\'t confirm shipping for this cart.</b>' +
    '<p>Pickup-only and freight parts may need to ship as a separate order &mdash; this is confirmed at checkout, or call the yard to check before you pay.</p></div></div>';

  function cartAlertMarkup(shipInfo) {
    if (!shipInfo) return UNKNOWN_ALERT;
    return shipInfo.alert || '';
  }

  function cartMarkup(cart, shipInfo) {
    if (!cart.item_count) {
      return '<div class="empty-state" style="margin:24px 0;border:0;">' +
        '<h2 class="h3">Nothing in the cart yet</h2>' +
        '<p class="muted">Find your part by number, or start with the part type.</p>' +
        '<button type="button" class="btn" data-cart-close>Continue shopping</button></div>';
    }
    return cart.items.map(function (line, i) {
      var img = line.image
        ? '<img src="' + esc(line.image) + '" alt="" loading="lazy">'
        : '';
      return '<div class="cart-item">' +
        '<a class="cart-item__media" href="' + esc(line.url) + '">' + img + '</a>' +
        '<div><a href="' + esc(line.url) + '" style="font-weight:650;font-size:14px;line-height:1.35;display:block;">' +
        esc(line.product_title) + '</a>' +
        '<div class="card__meta" style="margin-top:6px;">' +
        (line.sku ? '<span>Part&nbsp;ID <b>' + esc(line.sku) + '</b></span>' : '') +
        '<span>Qty ' + line.quantity + '</span></div>' +
        '<div class="card__meta" style="margin-top:4px;">' + shipLabelMarkup(line, shipInfo) + '</div>' +
        '<button type="button" class="small muted" data-cart-remove="' + (i + 1) +
        '" style="border:0;background:none;padding:0;margin-top:8px;text-decoration:underline;cursor:pointer;">Remove</button>' +
        '</div>' +
        '<div class="cart-item__price" style="text-align:right;"><span class="price" style="font-size:16px;">' +
        money(line.final_line_price) + '</span></div>' +
        '</div>';
    }).join('');
  }

  function openCart(cart, shipInfo, trigger) {
    if (!cartEl) {
      cartEl = document.createElement('div');
      cartEl.className = 'cart-drawer';
      cartEl.hidden = true;
      document.body.appendChild(cartEl);
      on(cartEl, 'click', function (e) {
        if (e.target.closest('[data-cart-close]')) {
          closeCart();
        }
        var remove = e.target.closest('[data-cart-remove]');
        if (remove && !cartEl.hasAttribute('aria-busy')) {
          cartEl.setAttribute('aria-busy', 'true');
          remove.disabled = true;
          remove.textContent = 'Removing…';
          var error = $('[data-drawer-error]', cartEl);
          error.hidden = true;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: Number(remove.getAttribute('data-cart-remove')), quantity: 0 })
          }).then(function (r) {
            if (!r.ok) throw new Error('Could not remove this part. Please try again.');
            return r.json();
          }).then(function (c) {
            return fetchShippingData().catch(function () { return null; }).then(function (ship) {
              if (!cartEl.hidden) openCart(c, ship);
              syncCount(c);
            });
          }).catch(function (err) {
            error.textContent = err.message;
            error.hidden = false;
            remove.disabled = false;
            remove.textContent = 'Remove';
          }).finally(function () {
            cartEl.removeAttribute('aria-busy');
          });
        }
      });
    }

    cartEl.innerHTML =
      '<button class="cart-drawer__scrim" data-cart-close aria-label="Close cart" tabindex="-1"></button>' +
      '<div class="cart-drawer__panel" role="dialog" aria-modal="true" aria-label="Cart">' +
        '<div class="cart-drawer__head"><h2>' + (trigger ? 'Added to your cart' : 'Your cart (' + cart.item_count + ')') + '</h2>' +
        '<button class="icon-btn" data-cart-close aria-label="Close">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>' +
        '</button></div>' +
        '<div class="cart-drawer__items"><p class="form-error" role="alert" data-drawer-error hidden></p>' +
        (cart.item_count ? cartAlertMarkup(shipInfo) + ((shipInfo && shipInfo.b2b_carrier_help) || '') : '') + cartMarkup(cart, shipInfo) + '<div data-saved-pickup></div></div>' +
        (cart.item_count
          ? '<div class="cart-drawer__foot">' +
            '<div class="cart-drawer__row"><span>Parts subtotal</span><b>' + money(cart.total_price) + '</b></div>' +
            '<p class="small muted" style="margin:0 0 12px;">Shipping is a flat rate, shown on each item above. Shipping and any tax are added at checkout.</p>' +
            '<form action="' + esc(window.ABM.routes.cart) + '" method="post" data-cart-checkout><div data-delivery-controls></div><button type="submit" name="checkout" class="btn btn--lg btn--full"' + (!window.ABMCartPolicy || window.ABMCartPolicy.reason(shipInfo) ? ' disabled' : '') + '>Continue to checkout</button></form>' +
            '<div class="cart-drawer__links"><button type="button" class="link" data-cart-close>Keep shopping</button>' +
            '<a href="' + esc(window.ABM.routes.cart) + '" class="link">Edit cart</a></div>' +
            '</div>'
          : '') +
      '</div>';

    cartEl.hidden = false;
    var announceCart = function () {
      document.dispatchEvent(new CustomEvent('abm:cart', { detail: { cart: cart, ship: shipInfo, root: cartEl } }));
    };
    var loadedDelivery = document.querySelector('script[data-abm-delivery]');
    if (loadedDelivery && loadedDelivery.dataset.loading !== 'true') announceCart();
    else if (loadedDelivery) loadedDelivery.addEventListener('load', announceCart, { once: true });
    else {
      var deliveryScript = document.createElement('script');
      deliveryScript.src = window.ABM.deliveryScript;
      deliveryScript.dataset.abmDelivery = '';
      deliveryScript.dataset.loading = 'true';
      deliveryScript.onload = function () {
        delete deliveryScript.dataset.loading;
        announceCart();
      };
      document.head.appendChild(deliveryScript);
    }
    document.body.style.overflow = 'hidden';
    // Removing a line re-renders this panel, so re-point the trap at the new node but
    // keep the original trigger — the control to return to is still the one that opened it.
    trapFocus(cartEl.querySelector('.cart-drawer__panel'), openDialog ? dialogTrigger : (trigger || document.activeElement));
    var closeBtn = cartEl.querySelector('.icon-btn[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }

  function syncCount(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    $$('[data-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
  }

  /* ------------------------------------------------------- add to cart */
  var addingToCart = false;
  $$('[data-product-form]').forEach(function (form) {
    on(form, 'submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (addingToCart) return;
      addingToCart = true;
      var trigger = e.submitter || $('[data-add-button]', form);
      var buttons = $$('[data-add-button]');
      var labels = buttons.map(function (button) { return button.textContent; });
      var note = $('[data-cart-error]', form);
      $$('[data-cart-error]').forEach(function (error) { error.hidden = true; error.textContent = ''; });
      var ship = $('[name="properties[_ship]"]', form);
      var item = {
        id: Number($('[name="id"]', form).value),
        quantity: requestedQuantity($('[name="quantity"]', form), 1)
      };
      if (ship) item.properties = { _ship: ship.value };
      buttons.forEach(function (button) { button.disabled = true; button.textContent = 'Adding…'; });
      function resetButtons() {
        addingToCart = false;
        buttons.forEach(function (button, i) { button.disabled = false; button.textContent = labels[i]; });
      }

      Promise.resolve().then(function () {
        if (!window.ABMCartPolicy) throw new Error(window.ABM_SHIP.cartPolicy.unknown);
        return window.ABMCartPolicy.add(form.dataset.productUrl, function () { return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [item]
        })
      }); }); })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
          if (window.ABM.cartType === 'page') {
            resetButtons();
            window.location.href = window.ABM.routes.cart;
            return;
          }
          // The add has succeeded. A failed drawer refresh must not invite a second add.
          return loadCart()
            .then(function (result) {
              resetButtons();
              syncCount(result.cart);
              openCart(result.cart, result.ship, trigger);
            })
            .catch(function () {
              resetButtons();
              window.location.href = window.ABM.routes.cart;
            });
        })
        .catch(function (err) {
          resetButtons();
          if (trigger) trigger.focus();
          if (note) { note.textContent = err.message; note.hidden = false; }
          var policyLink = $('[data-cart-policy-link]', form);
          if (policyLink && err.code === 'cart_delivery_policy') policyLink.hidden = false;
          else window.alert(err.message);
        });
    });
  });

  // Header cart icon opens the drawer instead of navigating.
  $$('[data-cart-link]').forEach(function (link) {
    on(link, 'click', function (e) {
      if (!window.fetch || window.ABM.cartType === 'page') return;
      e.preventDefault();
      loadCart()
        .then(function (result) { openCart(result.cart, result.ship); })
        .catch(function () { window.location.href = link.href; });
    });
  });

  /* ------------------------------------------------------- cart page qty */
  $$('[data-cart-qty]').forEach(function (input) {
    on(input, 'change', function () {
      var note = document.getElementById(input.getAttribute('aria-describedby'));
      if (note) note.hidden = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(input.getAttribute('data-line')), quantity: requestedQuantity(input, 0) })
      }).then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'Could not update cart');
          window.location.reload();
        });
      }).catch(function (err) {
        input.value = input.defaultValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        if (note) { note.textContent = err.message; note.hidden = false; }
          var policyLink = $('[data-cart-policy-link]', form);
          if (policyLink && err.code === 'cart_delivery_policy') policyLink.hidden = false;
        else window.alert(err.message);
      });
    });
  });

  /* ----------------------------------------------- recently viewed parts */
  try {
    var pid = document.body.getAttribute('data-product-id');
    if (pid) {
      var key = 'abm:recent';
      var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (id) { return id !== pid; });
      list.unshift(pid);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    }
  } catch (e) { /* storage disabled — not important */ }

  /* --------------------------------------------------- sticky buy reveal */
  var sticky = $('[data-sticky-buy]');
  var buybox = $('[data-buybox]');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.style.visibility = entries[0].isIntersecting ? 'hidden' : 'visible';
    }).observe(buybox);
  }

  if (window.fetch) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(syncCount)
      .catch(function () {});
  }

  // Test-only hook: exposes the cart-shipping functions to tests/cart-shipping.test.js,
  // which runs this file under Node with a stub DOM. window.__ABM_CART_TEST__ is never set
  // in the storefront itself, so this is dead weight for every real shopper.
  if (typeof window !== 'undefined' && window.__ABM_CART_TEST__) {
    window.__ABM_CART_TEST__.shipLabelMarkup = shipLabelMarkup;
    window.__ABM_CART_TEST__.cartAlertMarkup = cartAlertMarkup;
    window.__ABM_CART_TEST__.cartMarkup = cartMarkup;
    window.__ABM_CART_TEST__.UNKNOWN_SHIP_LABEL = UNKNOWN_SHIP_LABEL;
    window.__ABM_CART_TEST__.UNKNOWN_ALERT = UNKNOWN_ALERT;
    window.__ABM_CART_TEST__.requestedQuantity = requestedQuantity;
    window.__ABM_CART_TEST__.vehicleURL = vehicleURL;
    window.__ABM_CART_TEST__.productSearchURL = productSearchURL;
  }
})();
